interface ElmApp<T> {
  init: (config: { node: HTMLElement, flags: T }) => void
}

interface ElmModule<T> {
  Elm: {
    [key: string]: ElmApp<T>
  }
}

export function elmElementExists (name: string): boolean {
  return elmElement(name) !== null
}

export function initElmApp<T> (elmModule: ElmModule<T>, dynamicFlags?: T): void {
  const elmElements = Array.from(document.querySelectorAll('[data-elm-module]'))
  const topLevelKey = Object.keys(elmModule.Elm)[0]
  const node = elmElements.find(element => element.dataset.elmModule.startsWith(topLevelKey))
  const moduleName = node.dataset.elmModule
  return initElmAppWithNode(elmModule, moduleName, node, dynamicFlags)
}

export function initElmAppWithNode<T> (elmModule: ElmModule<T>, moduleName: string, node: HTMLElement, dynamicFlags?: T): void {
  const flags = buildFlags(node, dynamicFlags)
  const app = findElmApp(elmModule.Elm, moduleName)

  if (app == null) {
    console.error(`Error initializing Elm app: Module "${moduleName}" not found or does not have an init function.`)
    return
  }

  return app.init({
    node,
    flags
  })
}

function findElmApp (obj: any, moduleName: string): ElmApp<any> | null {
  if (typeof obj.init === 'function') {
    return obj
  }

  if (moduleName.includes('.')) {
    const parts = moduleName.split('.')
    let current = obj

    for (const part of parts) {
      if (current[part] === undefined || current[part] === null) return null
      current = current[part]

      if (current !== null && current !== undefined && typeof current.init === 'function') {
        return current
      }
    }
  }

  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      if (key === moduleName && typeof obj[key].init === 'function') {
        return obj[key]
      }

      const app = findElmApp(obj[key], moduleName)
      if (app != null) return app
    }
  }

  return null
}

function buildFlags<T> (node: HTMLElement, dynamicFlags?: T): object {
  const flags = {}

  for (const key in node.dataset) {
    if (key.startsWith('elmFlag')) {
      const name = key.substr(7)[0].toLowerCase() + key.substr(7).substring(1)
      flags[name] = node.dataset[key]
    }
  }

  if (dynamicFlags !== undefined) {
    Object.assign(flags, dynamicFlags)
  }

  return flags
}

function elmElement (name: string): HTMLElement | null {
  return document.querySelector(`[data-elm-module="${name}"]`)
}
